<template>
  <div class="common-layout">
    <el-container style="height: 100vh;">
      <AppAside />
      <el-container direction="vertical" style="flex: 1; overflow: hidden;">
        <AppHeader />
        <el-main style="flex: 1; overflow-y: auto; padding: 20px;">
          <router-view />
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import { onBeforeUnmount, onMounted, watch } from 'vue';
import AppAside from '@/core/components/Aside.vue';
import AppHeader from '@/core/components/Header.vue';
import { ElMessageBox } from 'element-plus';
import router, { user } from '@/core/router';
import { userAPI } from '@/features/user/api/user';
import {
  getProfileWarningKey,
  resetProfileWarningReminder,
} from '@/core/utils/loginSession';

export default {
  components: {
    AppAside,
    AppHeader
  },
  setup() {
    let stopWarningWatch = null;
    let profileUpdateHandler = null;
    let reminderPending = false;

    const getProfileWarnings = (currentUser) => {
      const warnings = Array.isArray(currentUser?.profileWarnings)
        ? currentUser.profileWarnings.filter(Boolean)
        : [];
      if (!warnings.length && currentUser?.profileCompliant === false) {
        warnings.push('当前资料未通过规范校验');
      }
      return warnings;
    };

    const showProfileWarnings = async () => {
      if (!localStorage.getItem('isLogin') || reminderPending) return;
      const warnings = getProfileWarnings(user.value);
      if (!warnings.length) return;

      const reminderKey = getProfileWarningKey();
      if (localStorage.getItem(reminderKey) === '1') return;
      localStorage.setItem(reminderKey, '1');
      reminderPending = true;

      const details = [
        ...warnings,
        '昵称需为 4-12 位英文字母或数字',
        '真实姓名需为 2-4 个汉字',
      ];
      try {
        await ElMessageBox.confirm(
          `检测到你的个人资料需要规范：\n\n${[...new Set(details)].map(item => `• ${item}`).join('\n')}\n\n请前往首页的“编辑资料”完成修改。`,
          '请规范个人资料',
          {
            confirmButtonText: '去修改资料',
            cancelButtonText: '稍后处理',
            type: 'warning',
            distinguishCancelAndClose: true,
          }
        );
        await router.push({ name: 'HomePage', query: { profile: 'edit' } });
      } catch {
        // 允许用户稍后处理，不阻断登录和其他页面使用。
      } finally {
        reminderPending = false;
      }
    };

    const refreshCurrentUserAfterProfileUpdate = async () => {
      resetProfileWarningReminder();
      try {
        const res = await userAPI.getUserInfo();
        if (res?.success && res.data) {
          user.value = res.data;
          localStorage.setItem('userInfo', JSON.stringify(res.data));
          await showProfileWarnings();
        }
      } catch (error) {
        console.error('刷新个人资料规范状态失败', error);
      }
    };

    onMounted(() => {
      profileUpdateHandler = refreshCurrentUserAfterProfileUpdate;
      window.addEventListener('profile-updated', profileUpdateHandler);
      stopWarningWatch = watch(
        () => ({
          profileCompliant: user.value.profileCompliant,
          profileWarnings: user.value.profileWarnings,
        }),
        showProfileWarnings,
        { deep: true, immediate: true }
      );
    });

    onBeforeUnmount(() => {
      stopWarningWatch?.();
      if (profileUpdateHandler) {
        window.removeEventListener('profile-updated', profileUpdateHandler);
      }
    });

  },
}
</script>

<style scoped>
.common-layout {
  overflow: hidden;
  height: 100vh;
  width: 100vw;
}

.aside {
  /* height: 100vh; */
}

.header {
  /* background-color: blue; */
  /* display: block; */
}

.main {
  /* background-color: bisque; */
  height: 100%;
}
</style>
